var map = {
	"./catalogo-2023.jpg": "c6d6",
	"./costa.jpg": "fcd9",
	"./lista_precios.jpg": "da0d",
	"./plan_lector.jpg": "9591",
	"./sierra.jpg": "d031"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87ca";